// extracted by mini-css-extract-plugin
export default {"container":"gg5tsJYS","chart":"IOMF5_8A","noData":"yvN00oCt"};